<template>
    <mySubPage>
        <div slot="header">
            <myNav>{{op=='add'?'配置产品':'修改产品配置'}}</myNav>
            <div class="flex-box bg-f8">
                <div class="flex-box-bd tleft">商品名称：{{goods_info.goods_cname}}</div>
                <div class="flex-box-bd tleft">面值：<span class="f-red">{{goods_info.new_price * 1}}元</span></div>
            </div>
        </div>
        <el-form class="pd-10" ref="form" :model="formData" :rules="rule" label-width="120px">
            <el-form-item label="已签供应商" prop="org_vendor_id">
                <el-radio-group v-model="formData.org_vendor_id">
                    <el-radio v-for="item in org_vendors" :key="item.org_vendor_id" :label="item.org_vendor_id">{{item.vendor_cname}}</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="供应商产品ID" prop="mac_goods_id">
                        <el-input v-model="formData.mac_goods_id" :placeholder="$t('input')"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="客户结算价" prop="cost_amt">
                        <el-input v-model="formData.cost_amt" :placeholder="$t('input')">
                            <span slot="append" class="f-red">元 (不填，取供应商结算价)</span>
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item :label="$t('status')" prop="org_goods_status">
                <el-radio-group v-model="formData.org_goods_status">
                    <el-radio v-for="item in org_goods_status" :key="item.key" :label="item.key">{{item.value}}</el-radio>
                </el-radio-group>
            </el-form-item>
        </el-form>
        <div slot="footer">
            <div class="flex-box bg-f8">
                <div class="flex-box-bd"></div>
                <span class="f-red" v-if="op == 'upd'">（警告：当前操作保存即立即生效，请慎重）</span>
                <el-button style="margin-right: 8px" @click="cancel">{{$t('cancel')}}</el-button>
                <el-button type="primary" @click="submit">{{$t('save')}}</el-button>
            </div>
        </div>
    </mySubPage>
</template>

<script>
    export default {
        data:function(){
            return{
                op: 'add',
                formData: {
                    goods_id:'',//新增时需要
                    org_goods_id:'',
                    org_vendor_id: '',
                    mac_goods_id: '',
                    cost_amt:'',
                    org_goods_status: '0'
                },
                rule: {
                    org_vendor_id: [{required: true, message: this.$t('select'), trigger: 'change'}],
                    mac_goods_id: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                    org_goods_status: [{required: true, message: this.$t('select'), trigger: 'change'}]
                },

                goods_info: {},
                org_vendors: [],
                org_goods_status: [],
            }
        },
        computed:{
        },
        mounted: function(){
            this.$parent.$parent.show_subview = true;
            var para = this.$base.getRequest();
            para.org_goods_id = para.org_goods_id || '';
            if(para.org_goods_id != ''){
                this.op = 'upd';
                this.formData.org_goods_id = para.org_goods_id;
                this.getInfo();
            }
            else{
                this.formData.goods_id = para.goods_id;
                this.getLoad();
            }
        },
        methods:{
            cancel: function(){
                this.$base.linkBack();
            },
            getLoad: function(){
                var data = {
                    goods_id: this.formData.goods_id
                };
                this.$base.showLoading();
                this.$request.sendPost("org-goods/before-add",data,(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.goods_info = data.goods_info;
                        this.org_vendors = data.org_vendors;
                        this.org_goods_status = data.org_goods_status;
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            },
            getInfo: function(){
                var data = {
                    org_goods_id: this.formData.org_goods_id
                };
                this.$base.showLoading();
                this.$request.sendPost("org-goods/before-upd",data,(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.formData = this.$base.leftJson(this.formData,data.info);
                        this.goods_info = data.goods_info;
                        this.org_vendors = data.org_vendors;
                        this.org_goods_status = data.org_goods_status;
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            },
            submit: function(){
                this.$refs["form"].validate((valid) => {
                    if (valid) {
                        var url = this.op=='upd'?"org-goods/upd":"org-goods/add";
                        this.$base.showLoading();
                        this.$request.sendPost(url,this.formData,(success,data,error)=>{
                            this.$base.hideLoading();
                            if(success){
                                this.$base.msgSuccess(error.errmsg);
                                this.relist = true;
                                this.$base.linkBack();
                            }
                            else{
                                this.$base.alertErr(error.errmsg);
                            }
                        });
                    } else {
                        this.$base.alertErr(this.$t('incomplete'));
                    }
                })
            }
        },
        beforeDestroy: function () {
            this.$parent.$parent.show_subview = false;
            this.$parent.$parent.relist = this.relist;
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/base/orggoods/save.vue